import React, { useContext, useRef } from "react";
import { chooseImage } from "../util/Helpers";
import AppContext from "../context";

function renderSRS(p, k) {
	// console.log(p);
	if (!p.airbag || p.airbag === "NOT DEPLOYED") return null;
	if (p.airbag.indexOf("MULTIPLE") > -1)
		return [
			<div
				className={
					"srs " +
					"srs-position-" +
					k +
					" srs-position-" +
					p.position?.replace(/ /g, "_") +
					" side"
				}
				key={1}
			>
				SRS
			</div>,
			<div
				className={
					"srs " +
					"srs-position-" +
					k +
					" srs-position-" +
					p.position?.replace(/ /g, "_") +
					" front"
				}
				key={2}
			>
				SRS
			</div>,
			<div
				className={
					"srs " +
					"srs-position-" +
					k +
					" srs-position-" +
					p.position?.replace(/ /g, "_") +
					" back"
				}
				key={3}
			>
				SRS
			</div>
		];
	if (p.airbag.indexOf("FRONT") > -1)
		return (
			<div
				className={
					"srs " +
					"srs-position-" +
					k +
					" srs-position-" +
					p.position?.replace(/ /g, "_") +
					" front"
				}
			>
				SRS
			</div>
		);
	if (p.airbag.indexOf("SIDE") > -1)
		return (
			<div
				className={
					"srs " +
					"srs-position-" +
					k +
					" srs-position-" +
					p.position?.replace(/ /g, "_") +
					" side"
				}
			>
				SRS
			</div>
		);
	if (p.airbag.indexOf("BACK") > -1)
		return (
			<div
				className={
					"srs " +
					"srs-position-" +
					k +
					" srs-position-" +
					p.position?.replace(/ /g, "_") +
					" back"
				}
			>
				SRS
			</div>
		);
	return null;
}

export default function Vehicle({ v, alt, boxed, k }) {
	// console.log(v);
	const vehicleType = chooseImage(v);
	const { setModal } = useContext(AppContext);
	const popover3 = useRef();
	return (
		<div className="vehicle-holder">
			{v.recallData?.length && !alt ? (
				<div
					style={{ textAlign: "center" }}
					onClick={() => setModal("recall-" + k)}
					onMouseOver={() => popover3.current.classList.add("show")}
					onMouseOut={() => popover3.current.classList.remove("show")}
				>
					<div
						className="compensation-popover"
						ref={popover3}
						style={{ marginLeft: -60 }}
					>
						This vehicle was involved in a recall that could have contributed to
						your accident.
					</div>

					<img src="/assets/product-recall.jpg" height="43" />
				</div>
			) : null}
			<div className={"vehicle " + vehicleType}>
				<img src={`/assets/types/${vehicleType}.png`} className="schema" />
				{alt && v.damage_area_1 ? (
					<img
						src="/assets/icon-impact.svg"
						className={`damage ${vehicleType} ${
							v.damage_area_1.split(" - ")[0]
						}`}
					/>
				) : null}

				{alt && v.damage_area_2 ? (
					<img
						src="/assets/icon-impact.svg"
						className={`damage ${vehicleType} ${
							v.damage_area_2.split(" - ")[0]
						}`}
					/>
				) : null}

				{v.participants.map((p, k) => {
					let injuryClassColor = "orange";
					if (p.injury === "NOT INJURED") injuryClassColor = "blue";
					if (
						!p.injury ||
						p.injury === "UNKNOWN" ||
						p.injury === "NONE DETECTED"
					)
						injuryClassColor = "gray";

					if (alt)
						return (
							<React.Fragment key={k}>
								<img
									src="/assets/icon-passenger.svg"
									className={
										"position position-" +
										(k + 1) +
										" " +
										p.position?.replace(/ /g, "_").toUpperCase()
									}
								/>
							</React.Fragment>
						);

					if (boxed)
						return (
							<React.Fragment key={p._id}>
								<div
									className={
										"position boxed position-" +
										(k + 1) +
										" " +
										p.position?.replace(/ /g, "_").toUpperCase() +
										" " +
										injuryClassColor
									}
								>
									<img src="/assets/pdf/passenger-icon.svg" />
									<span>{k + 1}</span>
								</div>
							</React.Fragment>
						);

					return (
						<React.Fragment key={p._id}>
							<div
								className={
									"position position-" +
									(k + 1) +
									" " +
									p.position?.replace(/ /g, "_").toUpperCase() +
									" " +
									injuryClassColor
								}
							>
								{k + 1}
							</div>
							{renderSRS(p, k + 1)}
						</React.Fragment>
					);
				})}
			</div>
		</div>
	);
}
